module.exports = __webpack_public_path__ + "static/media/camera.6c94c713.svg";